"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = _interopRequireDefault(require("@trs/config"));
var _utils = require("@trs/utils");
var _general = require("@trs/utils/lib/general");
var _Input = _interopRequireDefault(require("./Input.style"));
var _TooltipError = _interopRequireDefault(require("./TooltipError"));
var _Icon = _interopRequireDefault(require("../../icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var INPUT_MAX_LENGTH = _config["default"].INPUT_MAX_LENGTH;
var DEFAULT_INPUT_WIDTH = '100%';
var handleOnChange = function handleOnChange(event, type, isInputFocused) {
  var newEvent = event;
  if (type === 'number') {
    var regex = /^-?[0-9]*\.?[0-9]*/;
    var value = event.target.value;
    value = isInputFocused ? value : (0, _general.removeNumberFormatting)(value);
    var m = regex.exec(value);
    value = m && m[0] ? m[0] : '';
    newEvent.target.value = value;
  }
  return newEvent;
};
var formatValue = function formatValue(value, type, isNumber, isInputFocused, withLocaleFormatNumber) {
  if (!value || !withLocaleFormatNumber || isInputFocused || !isNumber) return value;
  return type === 'percentage' ? (0, _general.formatNumber)(value).concat('%') : (0, _general.formatNumber)(value);
};
var Input = function Input(_ref) {
  var onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    onChange = _ref.onChange,
    onKeyUp = _ref.onKeyUp,
    isDisabled = _ref.isDisabled,
    placeholder = _ref.placeholder,
    type = _ref.type,
    value = _ref.value,
    maxLength = _ref.maxLength,
    error = _ref.error,
    required = _ref.required,
    supportNegative = _ref.supportNegative,
    id = _ref.id,
    width = _ref.width,
    children = _ref.children,
    name = _ref.name,
    ariaLabel = _ref.ariaLabel,
    submitIconAriaLabel = _ref.submitIconAriaLabel,
    requiredFieldLabel = _ref.requiredFieldLabel,
    negativeValueLabel = _ref.negativeValueLabel,
    icon = _ref.icon,
    iconClick = _ref.iconClick,
    variant = _ref.variant,
    isFocused = _ref.isFocused,
    withLocaleFormatNumber = _ref.withLocaleFormatNumber,
    className = _ref.className,
    _ref$inputProps = _ref.inputProps,
    inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps;
  var _useState = (0, _react.useState)(isFocused),
    _useState2 = _slicedToArray(_useState, 2),
    isInputFocused = _useState2[0],
    setIsInputFocused = _useState2[1];
  var handleOnFocus = function handleOnFocus(ev) {
    setIsInputFocused(true);
    ev.stopPropagation();
    onFocus && onFocus(ev);
  };
  var handleOnBlur = function handleOnBlur(ev) {
    setIsInputFocused(false);
    ev.stopPropagation();
    onBlur && onBlur(ev);
  };
  var isNumber = type === 'number' || type === 'percentage';
  var hasError = !(0, _utils.isBlank)(error);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    className: "input-wrapper ".concat(className),
    hasError: hasError,
    isDisabled: isDisabled,
    isRequired: required && (0, _utils.isBlank)(value),
    width: width,
    icon: icon,
    variant: variant
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    id: id,
    name: name,
    onBlur: handleOnBlur,
    onChange: R.compose(onChange, function (ev) {
      return handleOnChange(ev, type, isInputFocused);
    })
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: isFocused,
    onFocus: handleOnFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    disabled: isDisabled,
    placeholder: placeholder,
    "aria-label": ariaLabel || placeholder,
    type: isNumber ? undefined : type,
    value: formatValue(value, type, isNumber, isInputFocused, withLocaleFormatNumber),
    maxLength: maxLength,
    autoComplete: "off",
    required: required
  }, inputProps)), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "input-icon",
    icon: icon,
    "aria-label": submitIconAriaLabel || 'Submit input content',
    onClick: function onClick() {
      iconClick('submit');
    }
  }), hasError && /*#__PURE__*/_react["default"].createElement(_TooltipError["default"], {
    error: error,
    id: "".concat(id, "Error")
  }), required && (0, _utils.isBlank)(value) && /*#__PURE__*/_react["default"].createElement(_TooltipError["default"], {
    error: requiredFieldLabel || 'This is a mandatory field',
    id: "".concat(id, "RequiredError")
  }), !supportNegative && (0, _utils.isNegative)(value) && /*#__PURE__*/_react["default"].createElement(_TooltipError["default"], {
    error: negativeValueLabel || 'Negative values are not supported',
    id: "".concat(id, "RequiredError")
  }), children);
};
Input.defaultProps = {
  name: '',
  error: undefined,
  placeholder: '',
  value: '',
  type: 'text',
  isDisabled: false,
  inputProps: {},
  maxLength: INPUT_MAX_LENGTH,
  onKeyUp: undefined,
  onKeyDown: undefined,
  onFocus: undefined,
  onChange: undefined,
  onBlur: undefined,
  required: false,
  supportNegative: true,
  width: DEFAULT_INPUT_WIDTH,
  children: null,
  ariaLabel: '',
  submitIconAriaLabel: '',
  requiredFieldLabel: '',
  negativeValueLabel: '',
  icon: '',
  iconClick: function iconClick() {},
  variant: 'outlined',
  isFocused: false,
  withLocaleFormatNumber: false,
  className: ''
};
Input.propTypes = {
  name: _propTypes["default"].string,
  children: _propTypes["default"].node,
  id: _propTypes["default"].string.isRequired,
  isDisabled: _propTypes["default"].bool,
  inputProps: _propTypes["default"].shape({}),
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  type: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),
  required: _propTypes["default"].bool,
  supportNegative: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  width: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  submitIconAriaLabel: _propTypes["default"].string,
  requiredFieldLabel: _propTypes["default"].string,
  negativeValueLabel: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  iconClick: _propTypes["default"].func,
  variant: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool,
  withLocaleFormatNumber: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
Input.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Input",
  "props": {
    "inputProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "name": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "union",
            "value": [{
              "name": "string"
            }, {
              "name": "number"
            }]
          }
        }]
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'text'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "maxLength": {
      "defaultValue": {
        "value": "APP_CONFIG.INPUT_MAX_LENGTH",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "onKeyUp": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onKeyDown": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onFocus": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onBlur": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "supportNegative": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "submitIconAriaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "requiredFieldLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "negativeValueLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "variant": {
      "defaultValue": {
        "value": "'outlined'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isFocused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "withLocaleFormatNumber": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(Input);
exports["default"] = _default;